import { useTranslation } from "@outschool/localization";
import {
  activitySchedulePath,
  sellerOrgPath,
  teachPath
} from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";

import * as Activity from "../../shared/Activity";
import {
  sellerOrgClubsPath,
  sellerOrgSectionsPath,
  teacherClassesPath,
  teacherClubsPath,
  teacherSectionsPath
} from "../../shared/Routes";

export function useEducatorClassroomBreadcrumbs(
  activity:
    | {
        uid: string;
        user_uid: string;
        title: string;
        isClub: boolean;
        hasTeacherSchedule: boolean;
      }
    | undefined
) {
  const { t } = useTranslation("client\\hooks\\Breadcrumbs");
  const { currentUser } = useSession();
  if (!activity) {
    return [];
  }

  const isOrgOwner = currentUser?.sellerOrg?.currentUserIsOwner;
  const nodes = isOrgOwner
    ? [
        {
          path: sellerOrgPath(),
          name: t("Manage")
        }
      ]
    : [
        {
          path: teachPath(),
          name: t("Teaching")
        }
      ];
  nodes.push(
    activity.isClub
      ? {
          path: isOrgOwner ? sellerOrgClubsPath() : teacherClubsPath(),
          name: t("Groups")
        }
      : activity.hasTeacherSchedule
      ? {
          path: teacherClassesPath(),
          name: t("Classes")
        }
      : {
          path: isOrgOwner ? sellerOrgSectionsPath() : teacherSectionsPath(),
          name: t("Sections")
        }
  );
  nodes.push({
    path:
      currentUser && Activity.canManage(activity, currentUser)
        ? activitySchedulePath(activity)
        : "", // what should we link to here?
    name: activity.title
  });
  return nodes;
}
